import React, { useContext } from "react";
import { accessUid as accessUidSelector, token as tokenSelector } from "common/selectors/auth.selectors";
import { currentUser } from "common/selectors/user.selectors";
import { useEffect } from "react";
import { useAppSelector } from "common/hooks/storeHooks";
import { RemoteStorageContext } from "common/components/RemoteStorage/RemoteStorageContext";

export const RemoteStorageSession: React.FC = () => {
  // Hooks
  const { remoteStorage } = useContext(RemoteStorageContext);

  // Selectors
  const user = useAppSelector(currentUser);
  const token = useAppSelector(tokenSelector);
  const accessUid = useAppSelector(accessUidSelector);

  // Connects and cleans up websocket connection
  useEffect(() => {
    if (token && user && !user.loading && user.id > 0 && !remoteStorage?.initialized) {
      void remoteStorage?.connect(user.uuid);
    }
    return () => {
      remoteStorage?.disconnect();
    };
  }, [token, user]);

  useEffect(() => {
    if (!accessUid || !remoteStorage?.initialized) return;

    void remoteStorage.appMessages.join(true);
  }, [accessUid, remoteStorage]);

  return <></>;
};
